namespace Ir.Components.Workbook.Settings.OrderByFieldsPopup {

    let orderFieldsPopupComponent: IOrderByFieldsPopup;
    export function showOrderFieldsPopup() {
        if (orderFieldsPopupComponent == null) {
            let $popup = $(`<orderby-fields-popup params="config: $data"></orderby-fields-popup>`);
            $popup.appendTo('body');
            ko.applyBindings({
                callback(component: IOrderByFieldsPopup) {
                    orderFieldsPopupComponent = component;
                    orderFieldsPopupComponent.show();
                }
            } as IOrderByFieldsPopupParams, $popup[0]);
        }
        else {
            orderFieldsPopupComponent.show();
        }
    }

    export interface IOrderByFieldsPopupParams {
        callback(o: IOrderByFieldsPopup);
    }

    interface IOrderByFieldsPopup {
        show();
    }

    interface IViewModel {
        popupConfig: DevExpress.ui.dxPopup.Properties;
        popupComponent: DevExpress.ui.dxPopup;
        gridConfig: DevExpress.ui.dxDataGrid.Properties;
        gridComponent: DevExpress.ui.dxDataGrid;
    }

    interface IParams {
        config: IOrderByFieldsPopupParams;
    }

    class OrderByField {
        queryName: string;
        order: Order;

        constructor(data: ReportField) {
            this.queryName = data?.queryName;
            this.order = data?.order() ?? Order.ASC;
        }
    }

    export function getViewModel(this: IViewModel, params: IParams) {
        let self = this;
        let dataSource: Array<OrderByField> = [];
        let fields: Array<ReportField> = []
        let widgetType: WidgetType = WidgetType.Report;

        self.gridConfig = {
            height: "100%",
            width: "100%",
            columns: [
                {
                    dataField: "queryName",
                    caption: "Name",
                    showEditorAlways: true,
                    lookup: {
                        dataSource: [],
                        displayExpr(e: ReportField) {
                            return replaceBasicHtmlContent(e?.displayName?.());
                        },
                        valueExpr: 'queryName',
                    }
                },
                {
                    dataField: "order",
                    caption: "Sort",
                    width: 100,
                    alignment: "left",
                    cellTemplate(container, info) {
                        return $("<div></div>").dxButton({
                            text: info.data.order === Order.ASC ? "Asc" : "Desc",
                            icon: info.data.order === Order.ASC ? "sortup" : "sortdown",
                            hint: "Sort",
                            width: 75,
                            stylingMode: "text",
                            onClick(btnEvt) {
                                let newOrder = info.data.order === Order.ASC ? Order.DESC : Order.ASC;
                                self.gridComponent.cellValue(info.rowIndex, "order", newOrder);
                                btnEvt.component.option("icon", newOrder === Order.ASC ? "sortup" : "sortdown");
                                btnEvt.component.option("text", newOrder === Order.ASC ? "Asc" : "Desc");
                            }
                        });
                    }
                }
            ],
            dataSource: [],
            paging: {
                enabled: false,
            },
            editing: {
                mode: 'cell',
                allowUpdating: true,
                allowAdding: true,
                allowDeleting: true,
                selectTextOnEditStart: true,
                startEditAction: 'click',
                useIcons: true,
                newRowPosition: 'last',
                confirmDelete: false
            },
            scrolling: {
                mode: 'virtual',
                useNative: false
            },
            sorting: {
                mode: 'none',
            },
            rowDragging: {
                allowReordering: true,
                onReorder(e) {
                    const visibleRows = e.component.getVisibleRows();
                    const toIndex = dataSource.findIndex((item) => item.queryName === visibleRows[e.toIndex].data.queryName);
                    const fromIndex = dataSource.findIndex((item) => item.queryName === e.itemData.queryName);

                    dataSource.splice(fromIndex, 1);
                    dataSource.splice(toIndex, 0, e.itemData);

                    e.component.refresh();
                },
            },
            toolbar: {
                items: [{
                    name: "addRowButton",
                    options: {
                        hint: 'Add a new field or metric',
                        onClick(e) {
                            if (widgetType === WidgetType.Pivot && dataSource.length >= 1) {
                                DevExpress.ui.notify("Two or more fields are not allowed on Pivot");
                                return;
                            }

                            let options = fields.filter(x => dataSource.filter(d => d.queryName === x.queryName).length === 0);
                            if (options.length === 0) {
                                DevExpress.ui.notify("There are no fields available to add to the sort order");
                            }
                            else {
                                self.gridComponent.addRow();
                                self.gridComponent.saveEditData();
                            }
                        }
                    }
                }]
            },
            onInitialized: function (e) {
                self.gridComponent = e.component;
            },
            onInitNewRow(e) {
                let orderByField = new OrderByField(null);

                let field = fields.find(x => dataSource.filter(d => d.queryName === x.queryName).length === 0);
                if (field.isMetric) {
                    orderByField.order = Order.DESC;
                }

                e.data = orderByField;
                e.data.queryName = field.queryName;
            },
            onEditorPreparing: function (e) {
                if (e.parentType === "dataRow") {
                    let orderByField: OrderByField = e.row.data;
                    if (e.dataField === "queryName") {
                        e.editorOptions.dataSource = fields.filter(x => dataSource.filter(d => d.queryName === x.queryName).length === 0 || orderByField.queryName === x.queryName);
                    }
                }
            }
        };

        self.popupConfig = {
            title: "Order By",
            showTitle: true,
            width: 450,
            height: 500,
            visible: false,
            toolbarItems: [{
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    icon: 'save',
                    stylingMode: 'contained',
                    type: 'default',
                    text: 'Save',
                    onClick(e) {
                        let save = () => {
                            if (widgetType === WidgetType.Pivot && dataSource.length > 1) {
                                DevExpress.ui.notify("Two or more fields are not allowed on Pivot");
                                return;
                            }

                            let orderFields = [];
                            for (let field of fields) {
                                field.orderIndex(null);
                            }

                            for (let row of dataSource) {
                                let orderIndex = dataSource.indexOf(row);
                                let field = fields.find(x => x.queryName === row.queryName);
                                field.orderIndex(orderIndex);
                                field.order(row.order);

                                orderFields.push({
                                    fieldName: row.queryName,
                                    order: row.order,
                                    orderIndex: orderIndex
                                });
                            }

                            let tabOrWidget = workbook.workbookConfig.activeTabOrWidget();
                            let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                            let saveColumnOrdering = () => {
                                reportConfig.saveColumnOrdering(orderFields, () => {
                                    if (tabOrWidget.drilldownManager.isDrilldown) {
                                        tabOrWidget.drilldownManager.refresh();
                                    }
                                    else {
                                        tabOrWidget.refresh();
                                    }
                                });

                                self.popupComponent.hide();
                            };

                            if (reportConfig && reportConfig.includeAllMetrics()) {
                                reportConfig.convertIncludeAllMetricToIndividualMetrics(() => {
                                    saveColumnOrdering();
                                });
                            }
                            else {
                                saveColumnOrdering();
                            }
                        }

                        if (self.gridComponent.hasEditData()) {
                            self.gridComponent.saveEditData().done(function () {
                                save();
                            });
                        }
                        else {
                            save();
                        }
                    }
                }
            }, {
                widget: 'dxButton',
                toolbar: 'bottom',
                location: 'after',
                options: {
                    text: 'Close',
                    icon: 'remove',
                    stylingMode: 'outlined',
                    type: 'normal',
                    onClick() {
                        self.popupComponent.hide();
                    }
                }
            }],
            onShowing(e) {
                let tabOrWidget = workbook.workbookConfig.activeTabOrWidget();
                let reportConfig = tabOrWidget.drilldownManager.activeReportConfig;
                widgetType = workbook.workbookConfig.activeTabOrWidget().widgetType();

                fields = reportConfig.fields().filter(x => x.visible);
                if (reportConfig.metricFields) {
                    for (let metricField of reportConfig.metricFields().filter(x => x.visible)) {
                        fields.push(metricField);
                    }
                }

                if (reportConfig.includeAllMetrics()) {
                    let mapping = MappingService.getCurrentMapping();
                    let metricFields = mapping.visibleMetrics.map(x => x.createMetricOrReportField(reportConfig.isOriginalTemplate) as MetricField);
                    fields = [...fields, ...metricFields];
                }

                dataSource = createInstances(OrderByField, fields.filter(x => x.orderIndex() !== null && x.orderIndex() !== undefined).sort((f1, f2) => f1.orderIndex() - f2.orderIndex()));
                self.gridComponent.columnOption("queryName", "lookup.dataSource", fields);
                self.gridComponent.option("dataSource", dataSource);
            },
            onShown() {
                if (self.gridComponent) {
                    self.gridComponent.updateDimensions();
                }
            },
            onInitialized: function (e) {
                self.popupComponent = e.component;
                if (params.config.callback && typeof params.config.callback === "function") {
                    params.config.callback({
                        show() {
                            self.popupComponent.show();
                        }
                    } as IOrderByFieldsPopup);
                }
            },
        };
    }
}